"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Monitor, LogOut } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/Button";
import { Badge } from "@/components/ui/Badge";
import { toast } from "@/components/ui/toast";
import { authApi } from "@/lib/api-client";
interface SessionRow {
  id: string;
  created_at: string;
  expires_at: string;
  current: boolean;
}
const fmt = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

/** Kartu "Sesi & Perangkat" — daftar sesi aktif, cabut per-sesi, logout semua. */
export function SessionManager() {
  const $ = _c(16);
  const [sessions, setSessions] = useState(null);
  const [busy, setBusy] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      authApi.listSessions().then(res => {
        if (res.success && res.data) {
          setSessions((res.data as {
            sessions: SessionRow[];
          }).sessions);
        } else {
          setSessions([]);
        }
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const load = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(load, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async id => {
      setBusy(id);
      const res_0 = await authApi.revokeSession(id);
      setBusy(null);
      if (res_0.success) {
        toast.success("Sesi dicabut");
        setSessions(s => s ? s.filter(x => x.id !== id) : s);
      } else {
        toast.error(res_0.error || "Gagal mencabut sesi");
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const revoke = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async () => {
      if (!confirm("Keluar dari semua perangkat lain? Kamu tetap login di perangkat ini.")) {
        return;
      }
      setBusy("all");
      const res_1 = await authApi.logoutAll();
      setBusy(null);
      if (res_1.success) {
        toast.success("Keluar dari semua perangkat");
        load();
      } else {
        toast.error(res_1.error || "Gagal keluar dari semua perangkat");
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const logoutAll = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CardTitle>{"Sesi & Perangkat"}</CardTitle>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== busy || $[6] !== sessions) {
    t5 = sessions && sessions.length > 1 && <Button variant="secondary" size="sm" onClick={logoutAll} loading={busy === "all"}><LogOut className="mr-1.5 h-4 w-4" /> Keluar semua</Button>;
    $[5] = busy;
    $[6] = sessions;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <CardHeader className="flex flex-row items-center justify-between gap-2">{t4}{t5}</CardHeader>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== busy || $[11] !== sessions) {
    t7 = <CardContent>{sessions === null ? <div className="h-16 skeleton rounded-lg" /> : sessions.length === 0 ? <p className="text-sm text-gray-500">Tidak ada sesi aktif.</p> : <ul className="divide-y divide-black/[0.06]">{sessions.map(s_0 => <li key={s_0.id} className="flex items-center justify-between gap-3 py-3"><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-black/[0.04] text-gray-500"><Monitor className="h-4 w-4" /></span><div><p className="text-sm font-medium text-gray-900 dark:text-white">Sesi {s_0.current && <Badge variant="success" className="ml-1 rounded-full">perangkat ini</Badge>}</p><p className="text-xs text-gray-500">Masuk {fmt(s_0.created_at)} · berlaku s/d {fmt(s_0.expires_at)}</p></div></div>{!s_0.current && <Button variant="ghost" size="sm" onClick={() => revoke(s_0.id)} loading={busy === s_0.id}>Cabut</Button>}</li>)}</ul>}</CardContent>;
    $[10] = busy;
    $[11] = sessions;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <Card>{t6}{t7}</Card>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}